// src/api/paymentMethodApi.js
import axiosClient from "./axiosClient";

const paymentMethodApi = {
  getAll: () => {
    return axiosClient.get(`/payment_method/getAll`, {
      withCredentials: true,
    });
  },
  getBySupplier: (supplierId) => {
    return axiosClient.get(`/payment_method/get-by-supplier/${supplierId}`, {
      withCredentials: true,
    });
  },
  upsert: (
    paymentId,
    paymentNo,
    paymentDescription,
    replacementValue,
    supplierId
  ) => {
    const data = {
      paymentId: paymentId,
      paymentNo: paymentNo,
      paymentDescription: paymentDescription,
      replacementValue: replacementValue,
      supplierId: supplierId,
    };
    return axiosClient.post(`/payment_method/upsert`, data, {
      withCredentials: true,
    });
  },
  delete: (paymentId) => {
    return axiosClient.delete(`/payment_method/${paymentId}`, {
      withCredentials: true,
    });
  },
};

export default paymentMethodApi;
